<div class="book-options container mt-4 mb-4">
  <div class="row justify-content-center">
    <div class="col text-center">
      <div class="d-flex flex-column flex-start">
        @if (canCreateBooking()) {
          <button class="btn btn-lg btn-default shadow-3" (click)="book()"><i class="material-icons icon">add_circle</i> {{'SHARED.chooseBookOrBlockModal.newAppointment' | translate}}</button>
        }
        @if (canCreateHoliday()) {
          <button class="btn btn-lg btn-default shadow-3" (click)="block()"><i class="material-icons icon">block</i> {{'SHARED.chooseBookOrBlockModal.blockTime' | translate}}</button>
        }
        @if (canPayWithTeya()) {
          <button class="btn btn-lg btn-default shadow-3" (click)="paywithTeya()"><i class="material-icons icon">account_balance_wallet</i> {{ 'SHARED.chooseBookOrBlockModal.teyaSoloPay' | translate }}</button>
        }
        @if (!provider && hasLegacyPosIntegration()) {
          <button class="btn btn-lg btn-default shadow-3" (click)="createNewInvoice()"><i class="material-icons icon mr-2">shopping_cart</i> {{ 'SHARED.createInvoiceModal.invoice' | translate }}</button>
        }
      </div>
    </div>
  </div>
</div>
